/* eslint-disable react-hooks/rules-of-hooks */
import { useIsAuthenticated } from '../providers/Auth';
import withConditionalRedirect from './withConditionalRedirect';

export default function withoutAuth(WrappedComponent, location = '/dashboard') {
    return withConditionalRedirect({
        WrappedComponent,
        location,
        getLocation: ({ query }) => {
            return query?.next || location;
        },
        clientCondition: function withoutAuthClientCondition() {
            return useIsAuthenticated();
        },
        serverCondition: function withoutAuthServerCondition(ctx) {
            return !!ctx.req?.cookies.session;
        }
    });
}
